import { render, staticRenderFns } from "./Neighbourhoods.vue?vue&type=template&id=b6fb09f8&"
import script from "./Neighbourhoods.vue?vue&type=script&lang=js&"
export * from "./Neighbourhoods.vue?vue&type=script&lang=js&"
import style0 from "./Neighbourhoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports